<script>
  import { timerDot, timerLine, timerLetter, timerWord, morseAudioOn } from './stores.js';
  import { userSettings, loadUserSettings, deleteLocalStorageSettings } from './userSettings.js';

  const TIMER_MIN = 250;

  let manageUserSettings = userSettings(loadUserSettings());


  const rgbToHex = (r, g, b) => '#' + [r, g, b].map(x => {
    const hex = Number(x).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }).join('');

  function getColor(colorKey) {
    const c = getComputedStyle(document.documentElement).getPropertyValue(colorKey);
    if (c.startsWith('#')) {
      return c;
    }
    let col = c.replace('rgb(', '');
    col = col.replace(')', '');
    col = col.split(',');
    const [r, g, b] = [col[0], col[1], col[2]];
    const hexCol = rgbToHex(r, g, b);
    return hexCol;
  }

  function setColor(cssCustomPropertyKey, value) {
    manageUserSettings(cssCustomPropertyKey, value);
    document.documentElement.style.setProperty(cssCustomPropertyKey, value);
  }

  // -- Timer management
  function updateDotTimer(newTimer) {
    const timer = newTimer.target.value >= TIMER_MIN ? newTimer.target.value : TIMER_MIN;
    manageUserSettings('timerDot', timer);
    timerDot.update(() => timer);
  }
  
  function updateLineTimer(newTimer) {
    const timer = newTimer.target.value >= TIMER_MIN ? newTimer.target.value : TIMER_MIN;
    manageUserSettings('timerLine', timer);
    timerLine.update(() => timer);
  }
  
  function updateLetterTimer(newTimer) {
    const timer = newTimer.target.value >= TIMER_MIN ? newTimer.target.value : TIMER_MIN;
    manageUserSettings('timerLetter', timer);
    timerLetter.update(() => timer);
  }
  
  function updateWordTimer(newTimer) {
    const timer = newTimer.target.value >= TIMER_MIN ? newTimer.target.value : TIMER_MIN;
    manageUserSettings('timerWord', timer);
    timerWord.update(() => timer);
  }

  // -- 
  function updateMorseAudioIsOn(checked) {
    const playSound = !checked.target.value;
    manageUserSettings('morseAudioOn', playSound);
    morseAudioOn.update(() => playSound);
  }

  // -- TODO: Set default settings
  function setFactorySettings() {
    document.documentElement.style.setProperty('--color-0', '#061a2d');
    document.documentElement.style.setProperty('--color-1', '#ffbb00');
    document.documentElement.style.setProperty('--color-2', '#00ffbf');
    document.documentElement.style.setProperty('--color-3', '#ffbb00');
    document.documentElement.style.setProperty('--color-4', '#ffffff');
    document.documentElement.style.setProperty('--color-5', '#f24545');
    timerDot.update(() => 1000);
    timerLine.update(() => 2000);
    timerLetter.update(() => 500);
    timerWord.update(() => 1500);
    deleteLocalStorageSettings();
  }

</script>

<!-- // ------------------------------------------------- \\-->
<!-- //                    TEMPLATE                       \\-->
<!-- // ------------------------------------------------- \\-->
<div>
  <h2 class="section-title">SETTINGS</h2>
  <div class="custom-colors">
    <div id="customBackgroundColor" class="color-input">
      <input
        type="color"
        id="color-0"
        name="backgroundColor"
        value="{ getColor('--color-0') }"
        on:change={ e => setColor('--color-0' ,e.target.value) }
      >
      <label for="backgroundColor">Background</label>
    </div>
    <div id="customTextColor" class="color-input">
      <input
        type="color"
        id="color-1"
        name="textColor"
        value="{ getColor('--color-1') }"
        on:change={ e => setColor('--color-1' ,e.target.value) }
      >
      <label for="textColor">Text</label>
    </div>
    <div id="customMorseLineColor" class="color-input">
      <input
        type="color"
        id="color-2"
        name="morseLineColor"
        value="{ getColor('--color-2') }"
        on:change={ e => setColor('--color-2' ,e.target.value) }
      >
      <label for="morseLineColor">Line</label>
    </div>
    <div id="customMorseDotColor" class="color-input">
      <input
        type="color"
        id="color-3"
        name="morseDotColor"
        value="{ getColor('--color-3') }"
        on:change={ e => setColor('--color-3' ,e.target.value) }
      >
      <label for="morseDotColor">Dot</label>
    </div>
    <div id="customLightColor" class="color-input">
      <input
        type="color"
        id="color-4"
        name="morseLightColor"
        value="{ getColor('--color-4') }"
        on:change={ e => setColor('--color-4' ,e.target.value) }
      >
      <label for="morseLightColor">light</label>
    </div>
    <div id="customSpaceColor" class="color-input">
      <input
        type="color"
        id="color-5"
        name="morseSpaceColor"
        value="{ getColor('--color-5') }"
        on:change={ e => setColor('--color-5' ,e.target.value) }
      >
      <label for="morseSpaceColor">Word space</label>
    </div>
  </div>
  
  <!-- Custom time for dot / line / letter / word -->
  <div class="custom-timers">
    <div id="customDotTimer" class="color-input">
      <input
        type="number"
        id="dot-timer"
        name="morseDotTimer"
        value="{ $timerDot }"
        on:blur={ e => updateDotTimer(e) }
      >
      <label for="morseDotTimer">Dot timer</label>
    </div>
    <div id="customLineTimer" class="color-input">
      <input
        type="number"
        id="dot-timer"
        name="morseLineTimer"
        value="{ $timerLine }"
        on:blur={ e => updateLineTimer(e) }
      >
      <label for="morseLineTimer">Line timer</label>
    </div>
    <div id="customLetterTimer" class="color-input">
      <input
        type="number"
        id="dot-timer"
        name="morseLetterTimer"
        value="{ $timerLetter }"
        on:blur={ e => updateLetterTimer(e) }
      >
      <label for="morseLetterTimer">Letter timer</label>
    </div>
    <div id="customWordTimer" class="color-input">
      <input
        type="number"
        id="dot-timer"
        name="morseWordTimer"
        value="{ $timerWord }"
        on:blur={ e => updateWordTimer(e) }
      >
      <label for="morseWordTimer">Word timer</label>
    </div>
  </div>
  
  <div id="customAudio" class="color-input">
    <input
      class="super-checkbox"
      type="checkbox"
      id="playAudio"
      name="morseAudio"
      on:change="{ e => updateMorseAudioIsOn(e) }"
      bind:checked={ $morseAudioOn }
    >
    <label for="morseAudio">Play audio</label>
  </div>


  <!-- Space between sign / letter / word -->

  <!-- Set factory values -->
  <button on:click="{setFactorySettings}">SET FACTORY SETTINGS</button>

  <h2 class="section-title">INFO</h2>
  <ul>
    <li>
      Made using svelte
    </li>
    <li>
      <a href="https://mmm.page/morsure">Morsure website</a>
    </li>
    <li>
      <a href="mailto:morsureapp@gmail.com">Feel free to drop an email</a>
    </li>
  </ul>
</div>

<!-- // ------------------------------------------------- \\-->
<!-- //                       STYLE                       \\-->
<!-- // ------------------------------------------------- \\-->
<style>
  input {
    padding: 0;
    background: transparent;
    color: var(--color-1);
  }

  input[type=color] {
    height: 50px;
    border: none;
  }

  input[type=number] {
    width: clamp(50px, 25%, 120px);
    padding: 5px;
  }

  a {
    color: var(--color-1);
    text-decoration: underline;
  }

  li {
    margin: 12px 0;
  }

  #customAudio {
    margin-bottom: 24px;
  }

  .section-title {
    text-align: center;
    font-weight: normal;
    letter-spacing: 4px;
    background: var(--color-1);
    color: var(--color-0);
  }

  .custom-colors {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 12px;
  }

  .custom-timers {
    margin-bottom: 12px;
  }
  .color-input {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .super-checkbox {
    accent-color: var(--color-1);
    color: var(--color-2);
    width: 2rem;
    height: 2rem;
  }
</style>